import { createContext, useContext, useState, useCallback, useMemo } from "react";

const AuthContext = createContext(null);
const STORAGE_KEY = "loveless_admin_session";

const getInitial = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.token && parsed.user) return parsed;
    }
  } catch (e) {
    // ignore
  }
  return { token: null, user: null };
};

export function AuthProvider({ children }) {
  const [authState, setAuthState] = useState(getInitial);

  const setAuth = useCallback((token, user) => {
    const next = { token, user };
    setAuthState(next);
    try {
      if (token && user) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // ignore
    }
  }, []);

  const clearAuth = useCallback(() => {
    setAuthState({ token: null, user: null });
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      // ignore
    }
  }, []);

  const value = useMemo(
    () => ({
      token: authState.token,
      user: authState.user,
      isAuthenticated: !!authState.token,
      setAuth,
      clearAuth,
    }),
    [authState.token, authState.user, setAuth, clearAuth]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}
